var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0099 11.3617L0.41048 2.47161C-0.136827 1.90609 -0.136827 0.989207 0.41048 0.423965C0.957304 -0.141322 1.8442 -0.141322 2.39097 0.423965L10.0001 8.29031L17.609 0.424194C18.1561 -0.141093 19.0429 -0.141093 19.5897 0.424194C20.1368 0.989481 20.1368 1.90632 19.5897 2.47184L10.9902 11.3619C10.7166 11.6446 10.3585 11.7857 10.0002 11.7857C9.6417 11.7857 9.28331 11.6443 9.0099 11.3617Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dabdaaa7.svg";
export { ForwardRef as ReactComponent };